export enum CopilotSuggestedKnowledgeDataEventObject {
  VIEWER_KNOWLEDGE_LIST = 'viewer_knowledge_list',
  RELATED_KNOWLEDGE_PILL = 'related_knowledge_pill',
  SIMILAR_INQUIRY_PILL = 'similar_inquiry_pill',
}
